import type { FormInstance } from "antd/es/form/Form";
import { type FC } from "react";

import type { SiteBatchUpdateEntity } from "src/app/features/Site/types/SiteBatchUpdateEntity";
import { OrgUnitBatchUpdateForm } from "../../../../../components/DrawerForm/BatchUpdateDrawer/OrgUnitBatchUpdateForm";
import { useLoadFormDefinitionQuery } from "../../../../../components/Form/services/server/serverApi";
import type { SearchFormProps } from "../../../../../components/Form/types/types";

type SiteBatchUpdateFormProps = SearchFormProps<SiteBatchUpdateEntity> & { form?: FormInstance };

export const SiteBatchUpdateForm: FC<SiteBatchUpdateFormProps> = ({ searchCallback, form }) => {
    const { data: formDefinition } = useLoadFormDefinitionQuery("site");

    return (
        // OrgUnitBatchUpdateForm for use in both SiteGroups and Sites
        <OrgUnitBatchUpdateForm form={form} searchCallback={searchCallback} formDefinition={formDefinition} />
    );
};
